// extracted by mini-css-extract-plugin
export default {"fullWidth":"po-z","image":"qo-z","lazyLoadPicture":"ro-z","lazyLoadSpinner":"so-z","lazyLoadSpin":"to-z","lazyLoadImage":"uo-z","hasStyledAspectRatio":"vo-z"};